import React from 'react';
import { Grid, Menu, Button, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const styles = {
  menuButton: {
    borderRadius: 0,
  },
};

function ActionsDropdownMenu({ onChange, options }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid>
      <Button
        id="bulk-update-menu-button"
        aria-describedby={open ? 'basic-menu' : undefined}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup
        aria-expanded={open ? 'true' : undefined}
        aria-owns="basic-menu"
        style={styles.menuButton}
        size="small"
        color="primary"
        variant="contained"
        disableFocusRipple
        disableRipple
        onClick={handleClick}
      >
        Bulk Update
        {' '}
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
        PaperProps={{ style: { borderRadius: 0, minWidth: 140 } }}
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            onClick={(e) => {
              onChange(e);
              setAnchorEl(null);
            }}
            name={option}
            value={option}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </Grid>
  );
}

export default ActionsDropdownMenu;
